import { createSelector } from '@reduxjs/toolkit';
// @ts-expect-error - Untyped import
import { getFileUploadListForCurrentThreadId } from '../../file-uploads/selectors/getFileUploadListForCurrentThreadId';
// @ts-expect-error - Untyped import
import { hasUnansweredQuickReplyMessage as hasUnansweredQuickReplyMessageSelector } from '../../selectors/chatSelectors';
// @ts-expect-error - Untyped import
import { getAllowUserInput } from '../../thread-histories/selectors/getAllowUserInput';
// @ts-expect-error - Untyped import
import { getCurrentThreadId } from '../../thread-history/selectors/getCurrentThreadId';
import { STUBBED_THREAD_ID } from '../../threads/constants/stubbedThreadId';
import { getShouldDisableAttachments } from '../../widget-ui/selectors/getShouldDisableAttachments';

// TODO: Better typing for Thread once the immutable Record is migrated to TypeScript

const threadFromProps = (_state, props) => props.thread;
export const canUploadAttachments = createSelector([getAllowUserInput, getFileUploadListForCurrentThreadId, hasUnansweredQuickReplyMessageSelector, getShouldDisableAttachments, threadFromProps], (allowUserInput, uploadList, hasUnansweredQuickReplyMessage, shouldHideAttachments, __thread) => {
  if (getCurrentThreadId(__thread) === STUBBED_THREAD_ID || !allowUserInput && hasUnansweredQuickReplyMessage || shouldHideAttachments) {
    return false;
  } else if (!uploadList) {
    return true;
  }
  return !uploadList.size;
});